<template>
  <div>
    <v-app-bar
      height="60"
      style="border: none"
      class="bg-header"
      clipped-left
      app
      flat>
      <v-app-bar-nav-icon
        v-if="isMobile"
        color="white"
        @click="onClickMobileMenu()" />
      <v-icon
        v-else
        color="white"
        @click="mini = !mini">
        {{ mini ? "mdi-menu" : "mdi-menu-open" }}
      </v-icon>
      <v-menu
        v-model="menus"
        :close-on-content-click="false"
        nudge-bottom="10"
        offset-y
        rounded>
        <template #activator="{ on, attrs }">
          <v-card
            elevation="0"
            v-bind="attrs"
            style="background: none !important"
            class="d-flex"
            v-on="on"
          >
            <div class="reactive">
              <v-avatar
                v-if="userAccount?.imageUserUrl"
                class="mx-3"
                :class="{ backgound: mini }"
                size="36px"
              >
                <img
                  alt="Avatar"
                  :src="userAccount?.imageUserUrl" />
              </v-avatar>
              <v-avatar
                v-else
                class="mx-3"
                :class="{ backgound: mini }"
                size="36px">
                <img
                  alt="Avatar"
                  src="/images/default-img.png" />
              </v-avatar>
              <span
                v-if="resultNofication"
                :class="[
                  'notification',
                  'absolute',
                  { 'new-patient-alive': hasNewMoveRoom }
                ]"
              >
                {{ resultNofication }}
              </span>
            </div>
            <v-list-item-content class="py-0 white--text card-user">
              <v-list-item-title class="header-user">
                {{ userAccount?.firstName }} {{ userAccount?.lastName }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ userAccount?.role }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-card>
        </template>

        <v-card
          max-height="600"
          width="230">
          <section
            class="d-flex pa-2 user-profile"
            @click="$router.push({ name: 'MyAccount' })">
            <div>
              <v-avatar
                v-if="userAccount?.imageUserUrl"
                class="mx-3"
                :class="{ backgound: mini }"
                size="36px"
              >
                <img
                  alt="Avatar"
                  :src="userAccount?.imageUserUrl" />
              </v-avatar>
              <v-avatar
                v-else
                class="mx-3"
                :class="{ backgound: mini }"
                size="36px">
                <img
                  alt="Avatar"
                  src="/images/default-img.png" />
              </v-avatar>
            </div>
            <v-list-item-content class="py-0 white--text card-user">
              <v-list-item-title class="black--text">
                {{ userAccount?.firstName }} {{ userAccount?.lastName }}
              </v-list-item-title>
              <v-list-item-subtitle class="black--text">
                {{ userAccount?.role }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </section>
          <v-divider></v-divider>
          <v-list>
            <v-list-item
              v-for="(item, i) in notification"
              :key="i"
              class="d-flex pa-2"
              @click="updateNotification(item.id)"
            >
              <div class="reactive">
                <div v-if="item.type === 'MOVE_ROOM'">
                  <v-avatar
                    v-if="item?.patient?.imageUrl"
                    class="mx-3"
                    :class="{ backgound: mini }"
                    size="36px"
                  >
                    <img
                      alt="Avatar"
                      :src="item?.patient?.imageUrl" />
                  </v-avatar>
                  <v-avatar
                    v-else
                    class="mx-3"
                    :class="{ backgound: mini }"
                    size="36px">
                    <img
                      alt="Avatar"
                      src="/images/default-img.png" />
                  </v-avatar>
                </div>
                <div v-else>
                  <v-avatar
                    class="mx-3"
                    :class="{ backgound: mini }"
                    size="36px">
                    <img
                      alt="Avatar"
                      src="/images/time-icon.svg" />
                  </v-avatar>
                </div>
              </div>
              <v-list-item-content class="py-0 card-user">
                <v-list-item-title
                  :style="item.idPush.length === 0 ? 'color: black' : 'color: #808080'"
                >
                  {{ item?.patient?.firstName }} {{ item?.patient?.lastName }}
                </v-list-item-title>
                <v-list-item-subtitle
                  :style="item.idPush.length === 0 ? 'color: black' : 'color: #808080'"
                  class="caption"
                >
                  {{ item.type === "MOVE_ROOM" ? "ได้เข้ามายังห้องของคุณ" : "รักษาครบเวลาแล้ว" }}
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  :style="item.idPush.length === 0 ? 'color: black' : 'color: #808080'"
                  class="caption"
                >
                  {{ timePassed(item.createdAt) }}
                </v-list-item-subtitle>
                <span
                  v-if="item.idPush.length === 0"
                  class="read-nofication"> </span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions class="white">
            <v-btn
              text
              block
              class="clear-btn"
              @click="clearNoTi()">
              อ่านแล้วทั้งหมด
            </v-btn>
          </v-card-actions>
          <v-card-actions class="white">
            <v-btn
              text
              block
              @click="viewMore()">
              ดูเพิ่มเติม
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <HeaderTitle
        :imgicon="$route?.meta.icon"
        :headername="$route?.meta.name" />
      <div
        class="d-flex"
        style="width: 14rem">
        <v-avatar
          class="mx-3"
          :class="{ backgound: mini }"
          size="36px">
          <img
            alt="Avatar"
            :src="clinicData?.imageUrl" />
        </v-avatar>
        <v-list-item-content class="py-0 white--text card-user">
          <v-list-item-title class="header-user">
            {{ clinicData?.clinicName }}
          </v-list-item-title>
          <!-- <v-list-item-subtitle>สาขาตลิ่งชัน</v-list-item-subtitle> -->
        </v-list-item-content>
      </div>

      <v-autocomplete
        :no-data-text="$t('alert.noDataSearch')"
        :items="itemsAutoSelect"
        item-text="fullName"
        :menu-props="{ bottom: true, offsetY: true, maxHeight: 200 }"
        rounded
        dense
        hide-details
        solo
        :label="$t('searchPatientOPDList')"
        return-object
        @change="selectItem($event)">
        <template #item="{ item }">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.fullName }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.type === "OPD" ? `${$t('statement.label.list')} OPD` : $t('patient.patient') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action>
            <v-icon>mdi-bitcoin</v-icon>
          </v-list-item-action> -->
        </template>
      </v-autocomplete>

      <ButtonTootip
        bottom
        color="#F3479A"
        icon="mdi-view-compact-outline"
        :tooltip="$t('toolTip.queuePage')"
        :to="{ name: 'QueuePage' }"
      />
      <ButtonTootip
        bottom
        color="#00B558"
        icon="mdi-account-multiple-plus-outline"
        :tooltip="$t('toolTip.addPatient')"
        :to="{ name: 'PatientCreate' }"
      />
      <ButtonTootip
        bottom
        icon="mdi-calendar-month-outline"
        color="#FFC328"
        :tooltip="$t('toolTip.appointmentTable')"
        :to="{ name: 'Appointment' }"
      />
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      color="menu"
      clipped
      app>
      <v-list
        :style="listHeight"
        class="overflow-y-auto overflow-x-hidden my-1 py-0"
        dense>
        <v-list-item-group
          v-for="(item, index) in menuShowForRole"
          :key="`menu-${index}`"
          no-action
          mandatory>
          <v-list-group
            v-if="item.subMenu"
            :value="false"
            no-action>
            <template #activator>
              <v-list-item-icon v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="ml-2">
                {{ item.title }}
              </v-list-item-title>
            </template>
            <ListMenu
              v-for="(subMenu, i) in item.subMenu"
              :key="`${item.title}-${subMenu.title}-${i}`"
              :title="subMenu.title"
              :to="subMenu.to"
              :icon="subMenu.icon"
              icon-prepend
              is-submenu
            />
          </v-list-group>
          <ListMenu
            v-else
            :title="item.title"
            :to="item.to"
            :icon="item.icon"
            icon-prepend />
          <v-divider
            v-if="item.title === 'รายงาน'"
            class="my-2 border-linear">
          </v-divider>
        </v-list-item-group>
      </v-list>

      <template #append>
        <v-list-item :to="{ name: 'ClinicLogout' }">
          <v-list-item-icon v-if="mini">
            <v-icon color="white">
              mdi-logout
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <v-btn
              class="btn-logout text-capitalize white--text"
              :block="!mini"
              :min-width="mini ? '' : 'auto'"
              :class="{ 'px-0': mini }"
              depressed>
              {{ $t('logout') }}
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import MyAccountProvider from '@/resources/MyAccount'

import HeaderTitle from '@/components/HeaderTitle.vue'
import PatientProvider from '@/resources/PatientProvider'
import { getRole } from '@/assets/js/auth'
import ListMenu from './ListMenu.vue'
import ButtonTootip from './ButtonTootip.vue'

const MyAccountService = new MyAccountProvider()

const PatientService = new PatientProvider()

export default {
  name: 'NavigationDrawer',
  components: {
    ListMenu,
    HeaderTitle,
    ButtonTootip
    // Search
  },
  data () {
    return {
      query: {
        limit: 5
      },
      notification: [],
      resultNofication: null,
      idSearch: '',
      menus: false,
      mini: false,
      drawer: true,
      dataPatientAndOpd: [],
      menu: [
        {
          title: this.$t('navigationDrawer.dashBoard'),
          icon: 'mdi-view-dashboard-outline',
          to: 'DashBoard',
          roles: ['owner'],
          requiredCredit: ['Silver', 'Gold']
        },
        {
          title: this.$t('navigationDrawer.treatmentReport'),
          icon: 'mdi-signal-cellular-outline',
          to: 'TreatmentReport',
          roles: ['owner', 'admin']
        },
        {
          title: this.$t('navigationDrawer.queuePage'),
          icon: 'mdi-view-compact-outline',
          to: 'QueuePage',
          roles: ['owner', 'admin', 'cashier', 'doctor', 'manager', 'serviceStaff', 'reception']
        },
        {
          title: this.$t('navigationDrawer.appointment'),
          icon: 'mdi-calendar-month-outline',
          to: 'Appointment',
          roles: ['owner', 'admin', 'doctor', 'manager', 'serviceStaff', 'reception']
        },
        {
          title: this.$t('navigationDrawer.patient'),
          icon: 'mdi-account-circle-outline',
          to: 'Patient',
          roles: ['owner', 'admin', 'cashier', 'doctor', 'manager', 'stockManager', 'serviceStaff']
        },
        {
          title: this.$t('navigationDrawer.opdReport'),
          icon: 'mdi-file-document-multiple-outline',
          to: 'OpdReport',
          roles: ['owner', 'admin', 'cashier', 'doctor', 'manager', 'serviceStaff', 'reception']
        },
        {
          title: this.$t('navigationDrawer.doctor'),
          icon: 'mdi-account-supervisor-outline',
          to: 'Doctor',
          roles: ['owner', 'admin', 'manager', 'serviceStaff', 'reception']
        },
        {
          title: this.$t('navigationDrawer.ingredient'),
          icon: 'mdi-medical-cotton-swab',
          to: 'IngredientList',
          roles: ['owner', 'admin', 'doctor', 'manager', 'stockManager']
        },
        {
          title: this.$t('navigationDrawer.drugFormulaList'),
          icon: 'mdi-pill-multiple',
          to: 'DrugFormulaList',
          roles: ['owner', 'admin', 'doctor', 'manager', 'stockManager']
        },
        {
          title: this.$t('navigationDrawer.product'),
          icon: 'mdi-package-variant-closed',
          to: 'Product',
          roles: ['owner', 'admin', 'stockManager', 'reception']
        },
        {
          title: this.$t('navigationDrawer.stock'),
          icon: 'mdi-warehouse',
          to: 'StockBuy',
          roles: ['owner', 'admin', 'stockManager']
        },
        {
          title: this.$t('navigationDrawer.pos'),
          icon: 'mdi-cash-register',
          to: 'Pos',
          roles: ['owner', 'admin', 'cashier', 'manager']
        },
        {
          title: this.$t('navigationDrawer.posOrders'),
          icon: 'mdi-order-bool-descending',
          to: 'PosOrders',
          roles: ['owner', 'admin']
        },
        {
          title: this.$t('navigationDrawer.service'),
          icon: 'mdi-heart-pulse',
          to: 'Service',
          roles: ['owner', 'admin']
        },
        {
          title: this.$t('navigationDrawer.course'),
          icon: 'mdi-tag-outline',
          to: 'Course',
          roles: ['owner', 'admin', 'serviceStaff', 'reception']
        },
        {
          title: this.$t('navigationDrawer.setting'),
          icon: 'mdi-cog-outline',
          to: 'Setting',
          roles: ['owner', 'admin', 'cashier', 'manager', 'reception']
        }
      ]
    }
  },
  computed: {
    itemsAutoSelect () {
      return this.dataPatientAndOpd.map((item) => ({
        fullName: item?.opdNo
          ? `${item.opdNo} ${item.patient?.firstName} ${item.patient?.lastName}`
          : `${item.patientNo} ${item.telephone} ${item.firstName} ${item.lastName}`,
        id: item.id,
        type: item?.opdNo ? 'OPD' : 'Patient'
      }))
    },
    clinicData () {
      return this.$store.getters['Clinic/clinic']
    },
    userAccount () {
      return this.$store.getters['Branch/branch']
    },
    // route () {
    //   const findRoute = this.headerName.find((item) => item.routerName === this.$route.name)
    //   if (!findRoute) return ''
    //   return findRoute
    // },
    isMobile () {
      return this.$vuetify.breakpoint.width < 1024
    },
    listHeight () {
      if (this.isMobile) {
        return 'height: calc(100vh - 58px);'
      }
      return 'height: calc(100vh - 126px);'
    },
    menuShowForRole () {
      const role = getRole()
      const creditPackage = this.$store.getters['Credit/creditPackage']

      return this.menu.filter((item) => {
        const hasRole = !item.roles || item.roles.includes(role)
        const hasCredit = !item?.requiredCredit || item?.requiredCredit?.includes(creditPackage)
        return hasRole && hasCredit
      })
    },
    hasNewMoveRoom () {
      if (!this.notification || this.notification.length === 0) return false

      const now = new Date()

      return this.notification.some((item) => {
        if (item.type !== 'MOVE_ROOM') return false

        const createdAt = new Date(item.createdAt)
        const diffMinutes = (now - createdAt) / 1000 / 60

        return diffMinutes <= 3
      })
    }
  },
  mounted () {
    if (this.clinicData.userId) {
      this.getDataPatientAndOpd()
      this.getDataNotification()
      this.getDataReadApi()
    }
  },
  methods: {
    viewMore () {
      this.query.limit += 10
      this.getDataNotification()
    },
    timePassed (time) {
      const givenTime = this.$dayjs(time)
      const currentDate = this.$dayjs()

      const secondsPassed = currentDate.diff(givenTime, 'second')
      const minutesPassed = currentDate.diff(givenTime, 'minute')
      const hoursPassed = currentDate.diff(givenTime, 'hour')
      const daysPassed = currentDate.diff(givenTime, 'day')
      const monthsPassed = currentDate.diff(givenTime, 'month')

      if (secondsPassed < 60) {
        return `${secondsPassed} วินาทีที่ผ่านมา`
      } if (minutesPassed < 60) {
        return `${minutesPassed} นาทีที่ผ่านมา`
      } if (hoursPassed < 24) {
        return `${hoursPassed} ชั่วโมงที่ผ่านมา`
      } if (daysPassed < 30) {
        return `${daysPassed} วันที่ผ่านมา`
      }
      return `${monthsPassed} เดือนที่ผ่านมา`
    },

    // eslint-disable-next-line consistent-return
    selectItem (selectedItem) {
      // console.log('selectedItem', selectedItem)
      if (selectedItem?.type === 'OPD') {
        this.$router.replace({ name: 'OpdDetail', params: { id: selectedItem?.id } })
      } else if (selectedItem?.type === 'Patient') {
        this.$router.replace({ name: 'PatientDetail', params: { id: selectedItem?.id } })
      } else {
        return ''
      }
    },
    async updateNotification (id) {
      try {
        this.$store.dispatch('Loading/addLoading')
        await MyAccountService.updateNotification(id, { idPush: this.clinicData.userId })
        this.getDataNotification()
        this.getDataReadApi()
        this.$router.push({ name: 'QueuePage' })
      } catch (error) {
        console.error('[ERROR] updateNotification', error?.message)
        this.$notify.error(error?.message)
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    },
    async getDataPatientAndOpd () {
      try {
        this.$store.dispatch('Loading/addLoading')
        const { data } = await PatientService.getDataPatientAndOpd()
        this.dataPatientAndOpd = data
      } catch (error) {
        console.error('[ERROR] getDataPatientAndOpd', error?.message)
        this.$notify.error(error?.message)
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    },
    async getDataReadApi () {
      try {
        this.$store.dispatch('Loading/addLoading')
        const { data } = await MyAccountService.readApi()
        // this.notification = data

        this.resultNofication = data
      } catch (error) {
        console.error('[ERROR] getDataNotification', error?.message)
        this.$notify.error(error?.message)
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    },
    async getDataNotification () {
      try {
        this.$store.dispatch('Loading/addLoading')
        const { data } = await MyAccountService.notification({
          limit: this.query.limit
        })
        this.notification = data.results
      } catch (error) {
        console.error('[ERROR] getDataNotification', error?.message)
        this.$notify.error(error?.message)
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    },

    setDrawer (value) {
      this.drawer = value
    },
    goMyAccount () {
      this.$router.push({ name: 'MyAccount' })
    },
    onClickMobileMenu () {
      this.mini = false
      this.setDrawer(true)
    },
    async clearNoTi () {
      try {
        this.$store.dispatch('Loading/addLoading')
        const res = await MyAccountService.readAllApi()
        if (res.message === 'done') {
          this.resultNofication = null
        }
        this.getDataNotification()
        this.$notify.success('อ่านการแจ้งเตือนทั้งหมดแล้ว')
        this.$router.push({ name: 'QueuePage' })
      } catch (error) {
        console.error('[ERROR] clearAllNotifications', error?.message)
        this.$notify.error('เกิดข้อผิดพลาดในการอ่านการแจ้งเตือน')
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// ::-webkit-scrollbar {
//   background: var(--v-menu-base);
//   width: 2px;
// }
// ::-webkit-scrollbar-thumb {
//   background: #C1C1C1;
//   border-radius: 8px;
// }
// .search{
// z-index: 1;
// top: -8px;
// right: 0px;
// height: 50px;
// border-radius: 2rem;
// }
::-webkit-scrollbar {
  background: transparent;
  width: 0px;
}
::v-deep(.v-list-item-group .v-list-item--active) {
  background: linear-gradient(90deg, var(--v-menu-base) 0%, var(--v-primary-base) 100%);
  border-radius: 50px;
}
.user-profile {
  cursor: pointer;
  // position: fixed;
}
// .user-profile:hover{
//   background: #0E153A;
// }
.border-linear {
  border: 0;
  background: linear-gradient(90deg, #0e153a 1%, #219dab 50%);
  height: 2px;
}

.notification {
  display: flex;
  color: white;
  background-color: red;
  font-size: 8px;
  border-radius: 100%;
  width: 17px;
  height: 17px;
  justify-content: center;
  align-items: center;
  left: 40px;
  top: 0px;
}

.new-patient-alive {
  background-color: rgb(255, 200, 0) !important;
}
.card-user {
  width: 150px;
  position: relative;
}
.read-nofication {
  position: absolute;
  color: white;
  background-color: #219dab;
  font-size: 10px;
  border-radius: 100%;
  width: 10px;
  height: 10px;
  text-align: center;
  right: 0px;
}
.bg-header {
  background: linear-gradient(90deg, var(--v-menu-base) 0%, var(--v-primary-base) 100%);
}
.btn-logout {
  background-color: #3e4461 !important;
  border-radius: 50px;
}
::v-deep(.v-btn:not(.v-btn--round).v-size--default) {
  min-width: 34px;
  text-align: center;
}

.clear-btn {
  font-size: 12px;
}
</style>
